var _a, _b, _c;
import { Network } from "@zetamarkets/flex-sdk";
import SolanaDeployments from "../constants/solanaDeployments.json";
export var CHAINID;
(function (CHAINID) {
    CHAINID[CHAINID["ETH_MAINNET"] = 1] = "ETH_MAINNET";
    CHAINID[CHAINID["ETH_ROPSTEN"] = 3] = "ETH_ROPSTEN";
    CHAINID[CHAINID["ETH_RINKEBY"] = 4] = "ETH_RINKEBY";
    CHAINID[CHAINID["ETH_GOERLI"] = 5] = "ETH_GOERLI";
    CHAINID[CHAINID["HECO_TEST"] = 256] = "HECO_TEST";
    CHAINID[CHAINID["HECO_MAINNET"] = 128] = "HECO_MAINNET";
    CHAINID[CHAINID["O"] = 10] = "O";
    CHAINID[CHAINID["ARBITRUM"] = 42161] = "ARBITRUM";
    CHAINID[CHAINID["POLYGON"] = 137] = "POLYGON";
    CHAINID[CHAINID["ETH_KOVAN"] = 42] = "ETH_KOVAN";
    CHAINID[CHAINID["BSC_MAINNET"] = 56] = "BSC_MAINNET";
    CHAINID[CHAINID["BSC_TEST"] = 97] = "BSC_TEST";
    CHAINID[CHAINID["AVAX_FUJI"] = 43113] = "AVAX_FUJI";
    CHAINID[CHAINID["AVAX_MAINNET"] = 43114] = "AVAX_MAINNET";
})(CHAINID || (CHAINID = {}));
export var SUBGRAPH_URI = (_a = {},
    _a[CHAINID.ETH_MAINNET] = process.env.REACT_APP_V2_SUBGRAPHQL_URL ||
        "https://api.thegraph.com/subgraphs/name/ribbon-finance/ribbon-v2",
    _a[CHAINID.ETH_KOVAN] = process.env.REACT_APP_KOVAN_V2_SUBGRAPHQL_URL ||
        "https://api.thegraph.com/subgraphs/name/ribbon-finance/ribbon-v2-kovan",
    _a[CHAINID.AVAX_FUJI] = process.env.REACT_APP_FUJI_SUBGRAPHQL_URL ||
        "https://api.thegraph.com/subgraphs/name/ribbon-finance/ribbon-avax",
    _a[CHAINID.AVAX_MAINNET] = process.env.REACT_APP_AVAX_SUBGRAPHQL_URL ||
        "https://api.thegraph.com/subgraphs/name/ribbon-finance/ribbon-avax",
    _a[CHAINID.BSC_MAINNET] = process.env.REACT_APP_BSC_V2_SUBGRAPHQL_URL ||
        "https://bonsai-subgraph.byte-trade.com/subgraphs/name/bonsai",
    _a[CHAINID.BSC_TEST] = process.env.REACT_APP_BSCTEST_V2_SUBGRAPHQL_URL ||
        "https://coda-subgraph-test2.bttcdn.com/subgraphs/name/coda/coda-v2-t4",
    _a);
export var SOLANA_SUBGRAPH = "https://ribbon-solana.hasura.app/v1/graphql";
export var REACT_APP_BSCTEST_V2_Current_Price_URL = "https://price-service.bttcdn.com/v2/asset/price?symbol=ETH,BUSD,BTC";
// We just default to staging by default
export var isDevelopment = function () { return !isStaging() && !isProduction(); };
// We use the same environment for development and staging
// But we still need a switch to only show dev features locally
export var isStaging = function () {
    return process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === "staging";
};
export var isProduction = function () {
    return process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === "master";
};
export var isTreasury = function () {
    return process.env.REACT_APP_VAULT_COLLECTION === "treasury";
};
export var NODE_URI = (_b = {},
    _b[CHAINID.ETH_MAINNET] = process.env.REACT_APP_MAINNET_URI || "",
    _b[CHAINID.ETH_KOVAN] = process.env.REACT_APP_TESTNET_URI || "",
    _b[CHAINID.AVAX_MAINNET] = process.env.REACT_APP_AVAX_URI || "",
    // [CHAINID.AVAX_FUJI]: process.env.REACT_APP_FUJI_URI || "",
    _b[CHAINID.BSC_MAINNET] = process.env.REACT_APP_BSC_MAINNET_URI || "",
    _b[CHAINID.BSC_TEST] = process.env.REACT_APP_BSC_TEST_URI || "",
    _b);
export var getSolanaClusterURI = function () {
    return isDevelopment()
        ? process.env.REACT_APP_SOLANA_TESTNET_URI ||
            "https://api.devnet.solana.com"
        : process.env.REACT_APP_SOLANA_MAINNET_URI ||
            "https://solana-api.projectserum.com";
};
export var getSolanaAddresses = function () {
    return isDevelopment() ? SolanaDeployments.devnet : SolanaDeployments.mainnet;
};
export var getSolanaNetwork = function () {
    return isDevelopment() ? Network.DEVNET : Network.MAINNET;
};
export var getSubgraphqlURI = function () {
    return (isDevelopment()
        ? process.env.REACT_APP_BSC_TEST_SUBGRAPHQL_URL
        : process.env.REACT_APP_BSC_SUBGRAPHQL_URL) ||
        "";
};
// export const supportedChainIds = isDevelopment()
//   ? [CHAINID.ETH_KOVAN, CHAINID.AVAX_FUJI, CHAINID.BSC_TEST]
//   : [CHAINID.ETH_MAINNET, CHAINID.AVAX_MAINNET, CHAINID.BSC_MAINNET];
export var supportedChainIds = isDevelopment()
    ? [CHAINID.BSC_TEST]
    : [CHAINID.BSC_MAINNET];
export var allChainIds = [
    CHAINID.ARBITRUM,
    CHAINID.AVAX_FUJI,
    CHAINID.AVAX_MAINNET,
    CHAINID.BSC_MAINNET,
    CHAINID.BSC_TEST,
    CHAINID.ETH_GOERLI,
    CHAINID.ETH_KOVAN,
    CHAINID.ETH_MAINNET,
    CHAINID.ETH_RINKEBY,
    CHAINID.ETH_ROPSTEN,
    CHAINID.HECO_MAINNET,
    CHAINID.HECO_TEST,
    CHAINID.O,
    CHAINID.POLYGON,
];
/**
 * Multi chain env configs
 */
export var ENABLED_CHAINID = [
    CHAINID.ETH_MAINNET,
    CHAINID.AVAX_MAINNET,
    CHAINID.BSC_MAINNET
];
export var isChainIdEnabled = function (chainId) {
    return ENABLED_CHAINID.includes(chainId);
};
export var getENSSubgraphURI = function () {
    return isDevelopment()
        ? ""
        : process.env.REACT_APP_ENS_SUBGRAPHQL_URL ||
            "https://api.thegraph.com/subgraphs/name/ensdomains/ens";
};
export var getGovernanceSubgraphURI = function () {
    return isDevelopment()
        ? "https://api.thegraph.com/subgraphs/name/ribbon-finance/ribbon-governance-kovan"
        : process.env.REACT_APP_GOVERNANCE_SUBGRAPHQL_URL ||
            "https://api.thegraph.com/subgraphs/name/ribbon-finance/ribbon-governance";
};
var STAKING_ENABLED_CHAINID = [CHAINID.ETH_MAINNET];
export var isStakingEnabledForChainId = function (chainId) {
    return chainId && Boolean(STAKING_ENABLED_CHAINID.includes(chainId));
};
var EtherscanApi = process.env.REACT_APP_ETHERSCAN_API_KEY || "";
var SnowTraceApi = process.env.REACT_APP_SNOWTRACE_API_KEY || "";
var BscscanApi = process.env.REACT_APP_BSCSCAN_API_KEY || "";
export var GAS_URL = (_c = {},
    _c[CHAINID.ETH_MAINNET] = "https://api.etherscan.io/api?module=gastracker&action=gasoracle&apikey=" + EtherscanApi,
    _c[CHAINID.ETH_KOVAN] = "https://api.etherscan.io/api?module=gastracker&action=gasoracle&apikey=" + EtherscanApi,
    _c[CHAINID.AVAX_FUJI] = "https://api.snowtrace.io/api?module=gastracker&action=gasoracle&apikey=" + SnowTraceApi,
    _c[CHAINID.AVAX_MAINNET] = "https://api.snowtrace.io/api?module=gastracker&action=gasoracle&apikey=" + SnowTraceApi,
    _c[CHAINID.BSC_MAINNET] = "https://api.bscscan.com/api?module=gastracker&action=gasoracle&apikey=" + BscscanApi,
    _c[CHAINID.BSC_TEST] = "https://api.bscscan.com/api?module=gastracker&action=gasoracle&apikey=" + BscscanApi,
    _c);
//# sourceMappingURL=env.js.map